export const PreviewUploadImage = ({ image }: any) => {
    if (!image) return null;
    return (
        <div className="absolute top-0 left-0 w-[180px] h-[180px]">
            <img src={image} alt="Preview" className="w-full h-full object-cover" />
        </div>
    );
};
